import React from 'react';
import { InputSwitch } from 'primereact/inputswitch';

function PrimeReactInputSwitch(props) {
  const { name = '', isChecked = false, isDisabled = false, onChange = () => {}, ...rest } = props || {};
  return (
    <>
      <InputSwitch name={name} checked={isChecked} disabled={isDisabled} onChange={onChange} {...rest} />
    </>
  );
}

export default PrimeReactInputSwitch;
